module.exports = __webpack_public_path__ + "img/spanish.aaec6aa0.png";